const ENUM_LOCALE = {
  "PtBr": 1, "EnEu": 2, "EsEs": 3, "EsAr": 4, "PtPt": 5, "ZhCn": 6,
};

export function getLocaleCode(locale) {
  if (locale === "PtBr" || locale === "EnEu" || locale === "EsEs" || locale === "EsAr" || locale === "PtPt" || locale === "ZhCn") {
    return ENUM_LOCALE[locale];
  }
  return ENUM_LOCALE.PtBr;
}

export function getCodeLang(code) {
  switch (Number(code)) {
    case 1:
      return "PtBr";
    case 2:
      return "EnEu";
    case 3:
      return "EsEs";
    case 4:
      return "EsAr";
    case 5:
      return "PtPt";
    case 6:
      return "ZhCn";
    default:
      return "PtBr";
  }
}

export function getMomentLocale(locale) {
  switch (locale) {
    case 'PtBr':
      return 'pt'
    case 'EnEu':
      return 'en'
    case 'EsEs':
      return 'es'
    case 'EsAr':
      return 'es'
    case 'PtPt':
      return 'pt'
    case 'ZhCn':
      return 'zh-cn'
  }
}

export function getLocaleB(locale) {
  switch (locale) {
    case 'pt':
      return 'pt-br';
    case 'en':
      return 'en-us';
    case 'es':
      return 'es-ar';
    case 'cn':
      return 'zh-cn';
    default:
      return 'pt-br';
  }
}

export const ENUM_LOCALE_LIST = [
  { id: 1, name: 'PtBr', flag: 'br.png', locale: 'pt' },
  { id: 2, name: 'EnEu', flag: 'en.png', locale: 'en' },
  { id: 3, name: 'EsEs', flag: 'es.png', locale: 'es' },
  { id: 4, name: 'EsAr', flag: 'ar.png', locale: 'es' },
  { id: 5, name: 'PtPt', flag: 'pt.png', locale: 'pt-pt' },
  { id: 6, name: 'ZhCn', flag: 'zh-cn.png', locale: 'zh-cn' },
];